import { useParceiro } from "@/parceiros/contexto"

const LogoFazCred = ({ className }: { className: string }) => (
    <>
        {/* Duas versões do mesmo logo em vez de um filtro CSS: a marca tem arquivo próprio para fundo
            escuro, e recolorir a original com invert() distorce o azul. */}
        <img src="/brand/faz-cred.svg" alt="Faz Cred" className={`${className} dark:hidden`} />
        <img
            src="/brand/faz-cred-branco.svg"
            alt="Faz Cred"
            className={`hidden ${className} dark:block`}
        />
    </>
)

export const Marca = () => {
    const parceiro = useParceiro()
    const { marca } = parceiro

    return (
        <div className="mb-6 flex flex-col items-center gap-1.5">
            {marca.tipo === "imagem" ? (
                <>
                    <img src={marca.claro} alt={marca.alt} className="h-7 w-auto dark:hidden" />
                    <img
                        src={marca.escuro}
                        alt={marca.alt}
                        className="hidden h-7 w-auto dark:block"
                    />
                </>
            ) : (
                <span className="font-display text-2xl font-extrabold lowercase leading-none tracking-tight text-brand">
                    {marca.texto}
                </span>
            )}

            {parceiro.operadoPelaFazCred && (
                <span className="flex items-center gap-1.5 text-[11px] text-faint">
                    em parceria com <LogoFazCred className="h-3.5 w-auto" />
                </span>
            )}
        </div>
    )
}
